/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import UpdateIcon from '@material-ui/icons/Create';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { connect } from 'react-redux';
import { initDataConfig, handleChangeCartPhrase, handleClose } from './ConfigCartPhrase.services';
import { styles } from './ConfigCartPhrase.styles';
import { mainColor, UNIT } from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Modal from '../Modal';
import IconButton from '../IconButton';
import * as actions from '../../actions/index';
import { checkAccess } from '../../utils/admins';

class ConfigCartPhrase extends Component {
  state = {
    cartPhraseModal: false,
    newCartPhrase: ''
  };

  componentDidMount() {
    initDataConfig(this.props, this);
  }

  componentWillReceiveProps(props) {
    initDataConfig(props, this);
  }

  renderConfigCartPhrase = () => {
    const { newCartPhrase } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <Input
          margin='dense'
          id='newCartPhrase'
          label='Message'
          type='text'
          value={newCartPhrase}
          onChange={e => this.setState({ newCartPhrase: e.target.value })}
          fullWidth
          className={classes.textField}
          multiline
        />
      </div>
    );
  };

  render() {
    const { classes, cartPhrase } = this.props;
    const { cartPhraseModal } = this.state;

    return (
      <div>
        <div className='row ml-0 mr-0 mt-4'>
          <p className='col' style={{ fontSize: UNIT * 1.125 }}>
            Configurez un message informatif important sur votre panier
          </p>
        </div>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableRow>
              <TableCell
                align='center'
                className={classes.title}
                style={{ color: `${cartPhrase ? mainColor.colorClearGray : mainColor.colorGray}` }}
              >
                <p className='text-break'>
                  {cartPhrase || "Actuellement aucun message d'information"}
                </p>
              </TableCell>
              <TableCell align='center' className={classes.tableCell}>
                <IconButton
                  title='Modifiez votre message'
                  label='Edit'
                  className={classes.icon}
                  onClick={() => this.setState({ cartPhraseModal: true })}
                  disabled={!checkAccess('features', 'infoBasketMessage')}
                >
                  <UpdateIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <Modal
          isOpen={cartPhraseModal}
          color='secondary'
          title='Message informatif'
          header
          size='md'
          handleClose={() => handleClose(this)}
          onClick={() => {
            handleChangeCartPhrase(this);
          }}
          fixed
          btnTxt='Enregistrer'
        >
          {this.renderConfigCartPhrase()}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime }) {
  const { printers, dashboardConfig } = user;
  const { generalConfig, shop } = firebaseRealTime;
  const { webapp = {} } = generalConfig;
  const { phrases = {} } = webapp;
  const { cartPhrase } = phrases;
  return {
    configurations: shop,
    printers,
    dashboardConfig,
    cartPhrase
  };
}

ConfigCartPhrase.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(ConfigCartPhrase));
